// extracted by mini-css-extract-plugin
export default {"ranking":"index_ranking_-fr7a","list":"index_list_sOSAy","numIcon":"index_numIcon_CZRQC","red":"index_red_XJRDW"};